import React from 'react';
import PropTypes from 'prop-types';

const SimpleHomeIcon = ({ color = '#FFA800' }) => (
  <svg width="20" height="18" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M256 0L0 192H64V512H192V320H320V512H448V192H512L256 0Z" fill={color} />
  </svg>
);

SimpleHomeIcon.propTypes = {
  color: PropTypes.string,
};

export default SimpleHomeIcon;
